const jotFormUrl = 'https://restoreskills.jotform.com';

export const viewFormByFormID = (formId: string, url: string = '') => {
  if (url) {
    return url;
  } else {
    return `${jotFormUrl}/${formId}`;
  }
};

export const preFillSubmissionData = (data: any) => {
  let url = `${jotFormUrl}/${data.form_id}?`;
  Object.keys(data.answers).forEach((answer: any) => {
    const answersData = data.answers[answer].answer;
    const nameData = data.answers[answer].name;
    if (answersData && nameData !== 'hiddenUuid') {
      if (typeof answersData === 'object') {
        if (nameData === 'evaluationRecommendation') {
          url += `${encodeURIComponent(nameData)}=${encodeURIComponent(answersData?.join(','))}&`;
        } else {
          Object.keys(answersData).forEach((ans: any) => {
            url += `${encodeURIComponent(`${nameData}[${ans}]`)}=${encodeURIComponent(
              answersData[ans]
            )}&`;
          });
        }
      } else {
        url += `${encodeURIComponent(nameData)}=${encodeURIComponent(answersData)}&`;
      }
    }
  });

  url = url.replace(/&$/, '');
  return url;
};

type SignatureData = {
  documentId: string;
  embedKey: string;
};

export const getSignatureTemplateUrl = (signatureData: SignatureData) => {
  return `${jotFormUrl}/sign/${signatureData.documentId}/invite/${signatureData.embedKey}?signEmbed=1`;
};
